module.exports = __webpack_public_path__ + "img/symbol_5.19a3ca52.png";